module.exports = __webpack_public_path__ + "static/media/system.d62a3a13.svg";